import { ADMIN_ROLE } from "../../constants/global";
import { PROFILE, PUBLISHED, REVIEW, SUBMITTED_FOR_REVIEW } from "../../constants/status";


export const disableAndLock = (apcp, col, org_rol, statusOfModule, qTag, isLocked, curcat) => {

  let disableEdit = false;
  let showQlock = false;

  if(apcp){
    //apcp already has readonly logic 
    disableEdit = statusOfModule;
    return {disableEdit, showQlock};
  }

  if(col?.isReadOnly){//we ever used this flag?
      disableEdit = true;
  }
  else{//user edit in 'profile' section
    if(curcat===PROFILE){
      //admin
      if(org_rol===ADMIN_ROLE){
          if(qTag&&qTag.includes(REVIEW)){
            if(statusOfModule&&statusOfModule.toUpperCase()===SUBMITTED_FOR_REVIEW){
                showQlock = true;
            }
          }
      }
      else{
      //heduser
        if(qTag&&qTag.includes(REVIEW)){
          if((statusOfModule&&statusOfModule.toUpperCase()===SUBMITTED_FOR_REVIEW)){
            disableEdit = true;
            showQlock = true;
          }
        }
      }
    }
    
    else{//user edit in regular category
      //admin
      if(org_rol===ADMIN_ROLE){
        if(statusOfModule&&statusOfModule.toUpperCase()===PUBLISHED){
          disableEdit = true;
        }
        if(qTag&&qTag.includes(PROFILE)){
          if(qTag.includes(REVIEW)){
            if(statusOfModule&&statusOfModule.toUpperCase()===SUBMITTED_FOR_REVIEW){
                showQlock = true;
            }
          }
        }
      }else{
      //heduser edit in regular category
          if((statusOfModule && statusOfModule.toUpperCase()===PUBLISHED)||
            (statusOfModule&&statusOfModule.toUpperCase()===SUBMITTED_FOR_REVIEW)||
            (isLocked===true)){
              disableEdit = true;
          }
            
          if(qTag&&qTag.includes(PROFILE)){
              if(qTag.includes(REVIEW)){
                if((statusOfModule&&statusOfModule.toUpperCase()===SUBMITTED_FOR_REVIEW)){
                  showQlock = true;
                }
              }
          }
      }
    }
  }
  return {disableEdit, showQlock};
  
};